var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoCorporateinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.67 19.43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.19 14.47V9.09h-7.44V5h3.31V0H6.61v5h3.31v4.09H2.48v5.38H0v5h5.79v-5H3.31V9.92h6.61v4.55H7.44v5h5.79v-5h-2.48V9.92h6.61v4.55h-2.48v5h5.79v-5zM7.44.83h5.79v3.3H7.44zM5 18.6H.83v-3.3H5zm7.44 0H8.27v-3.3h4.13zm7.44 0h-4.17v-3.3h4.13z",
    fill: "#fdc800",
    "data-name": "Capa 1"
  }))));
}

export default SvgCoCorporateinline;